import { getMaxNumberByKey } from 'utilitys/helpers/general';

export const useMilestonesDistributionLogic = ({ ui, api }) => {
    const versionMaxLevel = getMaxNumberByKey({ list: api.getProjectVersionsList.data, key: 'maxLevel' });

    return { logic: { versionMaxLevel } };
};
